import { render, staticRenderFns } from "./Promoters.vue?vue&type=template&id=202f2ea6&scoped=true"
import script from "./Promoters.vue?vue&type=script&lang=js"
export * from "./Promoters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202f2ea6",
  null
  
)

export default component.exports